export { default } from './InputRange';
